import { Button, Separator } from "@dune/ui";
import { ArrowRight } from "lucide-react";
import { useFormContext } from "react-hook-form";
import GFAAutorisationsContainer from "../../component/gfa/GFAAutorisationsContainer";
import GFAReferencesContainer from "../../component/gfa/GFAReferencesContainer";
import { GFAAutorisationsAndReferencesFormData } from "../../component/gfa/useGFAAutorisationsAndReferencesForm";

interface GFAAutorisationsAndReferencesFormProps {
	onSubmit: (
		data: GFAAutorisationsAndReferencesFormData & { isNext?: boolean },
	) => void;
}

const GFAAutorisationsAndReferencesForm = ({
	onSubmit,
}: GFAAutorisationsAndReferencesFormProps) => {
	const { getValues, handleSubmit } =
		useFormContext<GFAAutorisationsAndReferencesFormData>();
	return (
		<div className="flex items-center justify-center p-6 w-full">
			<form
				onSubmit={handleSubmit(onSubmit)}
				className="flex-3 flex-col items-center justify-center p-4 w-full"
			>
				<div className="flex flex-col gap-6 w-full">
					<div className="flex flex-row gap-4">
						<h1 className="text-[#144C65] text-2xl font-medium">
							Autorisations de construire
						</h1>
					</div>
					<Separator />

					<GFAAutorisationsContainer />
					<Separator />
					<GFAReferencesContainer />
					<Separator />

					{/* Action buttons */}
					<div className="self-end flex flex-row gap-4">
						<Button
							className="self-end"
							type="button"
							variant="outline"
							onClick={() => {
								onSubmit?.({
									...getValues(),
									isNext: false,
								});
							}}
						>
							Enregistrer et fermer
						</Button>
						<Button
							className="self-end"
							type="button"
							variant="default"
							onClick={() => {
								onSubmit?.({
									...getValues(),
									isNext: true,
								});
							}}
						>
							Suivant
							<ArrowRight className="w-4 h-4" />
						</Button>
					</div>
				</div>
			</form>
		</div>
	);
};

export default GFAAutorisationsAndReferencesForm;
